Handlebars.registerHelper('json', function(context) {
  return JSON.stringify(context);
});

Handlebars.registerHelper('ifeq', function(arg1, arg2, options) {
  return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('ifnoteq', function(arg1, arg2, options) {
  return (arg1 != arg2) ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper('inc', function(value, options)
{
    return parseInt(value) + 1;
});

Handlebars.registerHelper('times', function(n, block) {
  var accum = '';
  for(var i = 0; i < n; ++i)
      accum += block.fn(i);
  return accum;
});

Handlebars.registerHelper("math", function(lvalue, operator, rvalue, options) {
  lvalue = parseFloat(lvalue);
  rvalue = parseFloat(rvalue);
      
  return {
      "+": lvalue + rvalue,
      "-": lvalue - rvalue,
      "*": lvalue * rvalue,
      "/": lvalue / rvalue,
      "%": lvalue % rvalue
  }[operator];
});
Handlebars.registerHelper("debug", function(optionalValue) {
  console.log("Current Context");
  console.log("====================");
  console.log(this);

  if (optionalValue) {
    console.log("Value");
    console.log("====================");
    console.log(optionalValue);
  }
});

Handlebars.registerHelper('ifIn', function(elem, list, options) {
  if(list.indexOf(elem) > -1) {
    return options.fn(this);
  }
  return options.inverse(this);
});
/* =========================================================
   rrNotify — themed information modal to replace native alert().
   ========================================================= */
function rrNotifyClose() {
  var m = document.getElementById('rr-notify');
  if (m) { m.classList.remove('is-open'); }
}
window.rrNotify = function (message, title) {
  var m = document.getElementById('rr-notify');
  if (!m) {
    m = document.createElement('div');
    m.id = 'rr-notify';
    m.className = 'rr-notify';
    m.innerHTML =
      '<div class="rr-notify__overlay" data-rr-notify-close></div>' +
      '<div class="rr-notify__box" role="dialog" aria-modal="true" aria-live="polite">' +
        '<div class="rr-notify__icon"><i class="fas fa-info-circle" aria-hidden="true"></i></div>' +
        '<div class="rr-notify__title"></div>' +
        '<div class="rr-notify__msg"></div>' +
        '<button type="button" class="rr-notify__ok" data-rr-notify-close>OK</button>' +
      '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function (e) {
      if (e.target.closest('[data-rr-notify-close]')) { rrNotifyClose(); }
    });
  }
  var titleEl = m.querySelector('.rr-notify__title');
  titleEl.textContent = title || '';
  titleEl.style.display = title ? 'block' : 'none';
  m.querySelector('.rr-notify__msg').textContent = message;
  m.classList.add('is-open');
};
document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { rrNotifyClose(); } });

/* =========================================================
   Free-sample order limit: at most 3 sample products per cart.
   Samples are the "{handle}-sample" products. This intercepts the
   native sample add-to-cart forms (product page + quick-view overlay)
   and exposes window.rrCheckSampleLimit for AJAX adders (collection).
   ========================================================= */
(function () {
  var SAMPLE_LIMIT = 3;

  function countSamples(cart) {
    return (cart && cart.items ? cart.items : []).filter(function (i) {
      return /-sample$/.test(i.handle || '');
    }).length;
  }

  // async check; calls onResult(isAllowed, currentCount). Fails open on error.
  window.rrCheckSampleLimit = function (onResult) {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { var n = countSamples(cart); onResult(n < SAMPLE_LIMIT, n); })
      .catch(function () { onResult(true, 0); });
  };

  window.rrSampleLimitMessage = 'There is a limit of ' + SAMPLE_LIMIT + ' sample per order, you reached max ' + SAMPLE_LIMIT + ' sample for this cart';
  window.rrSampleLimitTitle = 'Sample Limit';

  // Intercept native sample add-to-cart forms (class="sample-addtobag-form"):
  // enforce the 3-sample limit, then AJAX-add and open the cart drawer
  // (same flyout as Add to Cart) instead of navigating to /cart.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('sample-addtobag-form')) { return; }
    e.preventDefault();
    window.rrCheckSampleLimit(function (allowed) {
      if (!allowed) { window.rrNotify(window.rrSampleLimitMessage, window.rrSampleLimitTitle); return; }
      var idEl = form.querySelector('[name="id"]');
      var id = idEl && idEl.value;
      var btn = form.querySelector('button[type="submit"]');
      if (btn) { btn.disabled = true; }
      var done = function () { if (btn) { btn.disabled = false; } };
      if (id && window.rrCartDrawerAdd) {
        window.rrCartDrawerAdd(id, 1)
          .catch(function () {
            if (window.rrNotify) { window.rrNotify('Sorry, we could not add this sample. Please try again.'); }
          })
          .then(done);
      } else {
        form.dataset.rrChecked = '1'; form.submit();
      }
    });
  }, true);
})();

/* =========================================================
   Cart flyout drawer: intercept Add to Cart, add via AJAX, and slide in
   the cart drawer instead of navigating to /cart. Free Sample is untouched.
   ========================================================= */
(function () {
  function el() { return document.getElementById('cartDrawer'); }
  function money(cents) { return '$' + (Number(cents) / 100).toFixed(2); }

  function openDrawer() {
    var d = el(); if (!d) return;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }
  function closeDrawer() {
    var d = el(); if (!d) return;
    d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }
  window.rrOpenCartDrawer = openDrawer;
  window.rrCloseCartDrawer = closeDrawer;

  function updateHeaderCount(n) {
    var b = document.querySelector('.cart .badge');
    if (b) { b.textContent = n; }
  }

  function sized(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  function lineHtml(item) {
    var title = item.product_title || item.title || '';
    var variant = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
    var img = sized(item.image);
    return '<div class="cd-line">' +
        (img ? '<a class="cd-line__media" href="' + item.url + '"><img src="' + img + '" alt=""></a>' : '') +
        '<div class="cd-line__info">' +
          '<a class="cd-line__name" href="' + item.url + '">' + title + '</a>' +
          (variant ? '<div class="cd-line__meta">' + variant + '</div>' : '') +
          '<div class="cd-line__meta">Qty ' + item.quantity + '</div>' +
          '<div class="cd-line__price">' + money(item.final_line_price) + '</div>' +
          '<button type="button" class="cd-line__rm" data-cd-remove="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>';
  }

  window.rrRenderCartDrawer = function () {
    var d = el(); if (!d) return Promise.resolve();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var body = d.querySelector('[data-cd-body]');
        var sub = d.querySelector('[data-cd-subtotal]');
        updateHeaderCount(cart.item_count);
        if (!cart.items || !cart.items.length) {
          if (body) body.innerHTML = '<div class="cart-drawer__empty">Your cart is empty.</div>';
          if (sub) sub.textContent = money(0);
          return cart;
        }
        if (body) body.innerHTML = cart.items.map(lineHtml).join('');
        if (sub) sub.textContent = money(cart.total_price);
        return cart;
      });
  };

  // Shared: AJAX-add an item, close the quick-view overlay if open, then
  // render and open the cart drawer. Used by Add to Cart AND Free Sample.
  window.rrCartDrawerAdd = function (id, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: Number(qty) || 1 })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
      .then(function () {
        var qb = document.getElementById('pc-quickbuy');
        if (qb && qb.classList.contains('is-open')) {
          qb.classList.remove('is-open');
          qb.setAttribute('aria-hidden', 'true');
          document.body.classList.remove('pc-modal-open');
          var content = qb.querySelector('.pc-modal__content');
          if (content) { content.innerHTML = ''; }
        }
        return window.rrRenderCartDrawer();
      })
      .then(function () { openDrawer(); });
  };

  // Intercept the main Add-to-Cart form (product page + quick-view overlay).
  // Uses jQuery delegation (same pattern the theme uses for #cartform) so it
  // reliably catches submits from dynamically-injected forms.
  $(document).on('submit', '#AddToCartForm', function (e) {
    e.preventDefault();
    var form = this;
    var idEl = form.querySelector('[name="id"]');
    var qtyEl = form.querySelector('[name="quantity"]');
    var id = idEl && idEl.value;
    var qty = (qtyEl && qtyEl.value) || 1;
    if (!id) { form.submit(); return; }
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; }
    window.rrCartDrawerAdd(id, qty)
      .catch(function () {
        if (window.rrNotify) { window.rrNotify('Sorry, we could not add this item. Please try again.'); }
      })
      .then(function () { if (btn) { btn.disabled = false; } });
  });

  // Remove a line from within the drawer; close controls.
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-cd-remove]');
    if (rm) {
      e.preventDefault();
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: rm.getAttribute('data-cd-remove'), quantity: 0 })
      }).then(function () { window.rrRenderCartDrawer(); });
      return;
    }
    if (e.target.closest && e.target.closest('[data-cd-close]')) { closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); } });
})();
